import { useMemo } from 'react'
import { Size } from '~/types/ThemeTypes'
import { mergeMultiStyleConfig, StyleThemingProps } from '~/utils/styleHelpers'

import { MangoButtonStyle, MangoButtonVariant } from './MangoButtonStyle'

type MangoButtonStyleProps = {
  variant?: MangoButtonVariant
  size?:
    Size.md | Size.sm | { base?: Size.md | Size.sm; md?: Size.md | Size.sm }
}

export const useMangoButtonStyleConfig = (props?: MangoButtonStyleProps) => {
  const variant = props?.variant ?? MangoButtonVariant.Default_300
  const size = props?.size ?? Size.md

  return useMemo(() => {
    return mergeMultiStyleConfig(MangoButtonStyle, {
      variant,
      size,
    } as StyleThemingProps)
  }, [variant, size])
}

// Re-export for convenience
export { MangoButtonVariant }
